import { observer } from 'mobx-react'
import './index.scss'

const FamousShops = observer(({ content }: { content: any }) => {
  return (
    <section className="shops-list">
      <div className="things-col__subtitle">{content.title}</div>
      <div className="shops-list__list">
        {content.list.map((l: any, i: number) => (
          <div className="shops-list__item"key={i} >
            <img src={l}  />
          </div>
        ))}
      </div>
    </section>
  )
})

export default FamousShops
